<template lang="html">
	<core-page>
		<div class="omapi-settings">
			<component :is="componentName">
				<template v-slot:tabs>
					<common-tabnav
						:active="currentTab"
						:tabs="allTabs"
						@go="goTo"
					/>
				</template>
			</component>
		</div>
	</core-page>
</template>

<script lang="js">
import { tabs } from '@/pages/mixins/tabs'

export default  {
	mixins : [ tabs ],
	data () {
		return {
			pageSlug : 'settings',
		}
	},
	computed : {
		componentName () {
			return `settings-${this.currentTab}`
		},
	},
	methods : {
		goTo (tab) {
			// According to the doc, the Billing tab should link here:
			// https://app.optinmonster.com/account/billing/
			if ('billing' === tab)  {
				if ('billing' === this.selectedTab) {
					this.goTab({ page: this.pageSlug })
				}

				let returnUrl = window.location.href
				return window.open(this.$urls.app(`account/billing/?utm_source=WordPress&utm_medium=BillingSettingsTab&utm_campaign=Plugin&return=${returnUrl}`))
			}

			if ('subaccounts' === tab)  {
				if ('subaccounts' === this.selectedTab) {
					this.goTab({ page: this.pageSlug })
				}

				let returnUrl = window.location.href
				return window.open(this.$urls.app(`account/users/?utm_source=WordPress&utm_medium=SubAccountsSettingsTab&utm_campaign=Plugin&return=${returnUrl}`))
			}

			this.goTab({ page: this.pageSlug, tab })
		},
	},
}
</script>

<style lang="scss">
	@import '../assets/scss/variables';
	@import '../assets/scss/pages/settings';
</style>
